import { createElementBlock as r, openBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 200 200"
};
function n(c, e) {
  return l(), r("svg", o, [...e[0] || (e[0] = [
    t("rect", {
      width: "193",
      height: "193",
      x: "3.5",
      y: "3.5",
      stroke: "currentColor",
      "stroke-width": "7",
      rx: "96.5"
    }, null, -1),
    t("path", {
      fill: "currentColor",
      d: "M148.011 51.989a6.79 6.79 0 0 0-9.602 0L100 90.398l-38.409-38.41a6.79 6.79 0 0 0-9.602 9.603L90.398 100l-38.41 38.409a6.79 6.79 0 1 0 9.603 9.602L100 109.602l38.409 38.409a6.79 6.79 0 0 0 9.602 0 6.79 6.79 0 0 0 0-9.602L109.602 100l38.409-38.409a6.79 6.79 0 0 0 0-9.602"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
